export default __webpack_public_path__ + "dist/media/hero-section.49928aba.png";